import { render, staticRenderFns } from "./Consultorialibros.vue?vue&type=template&id=0a7ffcac&scoped=true&"
import script from "./Consultorialibros.vue?vue&type=script&lang=js&"
export * from "./Consultorialibros.vue?vue&type=script&lang=js&"
import style0 from "./Consultorialibros.vue?vue&type=style&index=0&id=0a7ffcac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ffcac",
  null
  
)

export default component.exports